export default "__VITE_ASSET__CRAeK4hZ__"